/**
 * 我的活动子组件
 * @returns
 */
import {
  Box,
  Center,
  Flex,
  Grid,
  GridItem,
  HStack,
  Image,
  Text,
  Button,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Activity } from "@/types/activity";
import { format } from "date-fns";
import actIcon1 from "@/assets/images/activity_icon1.png";
import actIcon2 from "@/assets/images/activity_icon2.png";


type Props = {
  activity: Activity;
};

const ActivityItem = (props: Props) => {
  const { activity } = props;

  return (
    <Box>
      <Image src={activity.template1} w="100%" />
      <Flex mt="18px" justifyContent={"space-between"} alignItems="center">
        <Box>
          <Box>{activity.name}</Box>
          <HStack color={"#CBD1DF"} fontSize="12px">
            <HStack mr="25px">
              <Image src={actIcon1} />
              <Text>{format(new Date(activity.start_time), 'yyyy/MM/dd')}-{format(new Date(activity.end_time), 'yyyy-MM-dd')}</Text>
            </HStack>
            {/* <HStack>
              <Image src={actIcon2} />
              <Text>热度：{activity.page_view}</Text>
            </HStack> */}
          </HStack>
        </Box>
        {activity.status == "未开始" && (
          <Button
            w="80px"
            h="33px"
            bg="linear-gradient(90deg, #8E94A9 0%, #27314D 100%)"
            borderRadius="40px"
            color={"#DCE0EB"}
            fontSize="12px"
            fontWeight={"normal"}
            _hover={{
              bg: "linear-gradient(90deg, #27314D 0%, #8E94A9 100%)"
            }}
          >
            未开始
          </Button>
        )}
        {activity.status == "进行中" && (
          <Button
            w="80px"
            h="33px"
            bg="rgba(73, 106, 225, 0.1)"
            border={"1px solid #496AE1"}
            borderRadius="40px"
            color={"#496AE1"}
            fontSize="12px"
            fontWeight={"normal"}
          >
            进行中
          </Button>
        )}
        {activity.status == "已结束" && (
          <Button
            w="80px"
            h="33px"
            bg="#CBD1DF"
            border={"1px solid #8E94A9"}
            borderRadius="40px"
            color={"#27314D"}
            fontSize="12px"
            fontWeight={"normal"}
          >
            已结束
          </Button>
        )}
      </Flex>
    </Box>
  );
};
export default ActivityItem;
